import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.board.loading');
import { OnInit, Input } from '@angular/core';

@Component({
    selector: 'wiz-portal-board-loading',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.board.loading/view.scss */
:host {
  display: block;
  width: 100%;
}

@keyframes loading-bar {
  0% {
    width: 0%;
    margin-left: 0;
  }
  50% {
    width: 60%;
    margin-left: 20%;
  }
  100% {
    width: 0%;
    margin-left: 100%;
  }
}
:host ::ng-deep .animate-loading-bar {
  animation: loading-bar 1.5s ease-in-out infinite;
}`],
})
export class PortalBoardLoadingComponent implements OnInit {
    @Input() type: string = 'spinner';
    @Input() size: string = 'md';
    @Input() message: string = '';
    @Input() color: string = 'indigo';
    @Input() fullscreen: boolean = false;
    @Input() overlay: boolean = false;
    @Input() skeletonLines: number = 3;

    public async ngOnInit() { }

    public get sizeClass(): string {
        switch (this.size) {
            case 'xs': return 'w-4 h-4';
            case 'sm': return 'w-6 h-6';
            case 'md': return 'w-8 h-8';
            case 'lg': return 'w-12 h-12';
            case 'xl': return 'w-16 h-16';
            default: return 'w-8 h-8';
        }
    }

    public get colorClass(): string {
        switch (this.color) {
            case 'indigo': return 'text-indigo-600';
            case 'gray': return 'text-gray-400';
            case 'white': return 'text-white';
            case 'blue': return 'text-blue-600';
            case 'green': return 'text-green-600';
            case 'red': return 'text-red-600';
            default: return 'text-indigo-600';
        }
    }

    public get dotColorClass(): string {
        switch (this.color) {
            case 'indigo': return 'bg-indigo-600';
            case 'gray': return 'bg-gray-400';
            case 'white': return 'bg-white';
            case 'blue': return 'bg-blue-600';
            case 'green': return 'bg-green-600';
            case 'red': return 'bg-red-600';
            default: return 'bg-indigo-600';
        }
    }

    public get skeletonArray(): number[] {
        return Array(this.skeletonLines).fill(0);
    }
}

export default PortalBoardLoadingComponent;